import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../Components/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import Menu from "../Components/Menu";

const ContactUs = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | تماس با ما";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [allShops, setAllShops] = useState([]);
    const [showChat, setShowChat] = useState(false);
    const [ticketList, setTicketList] = useState([]);
    const [ticketText, setTicketText] = useState("");
    const [shopId, setShopId] = useState("");
    const [chatFile, setChatFile] = useState(null);
    // حالت‌های مودال
    const [showFilePreviewModal, setShowFilePreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    const handleFileChange = (file) => {
        setChatFile(file);
        if (file && file.type.startsWith("image/")) {
            const previewUrl = URL.createObjectURL(file);
            setPreviewImage(previewUrl);
            setShowFilePreviewModal(true);
        } else {
            // مدیریت فایل‌های غیرتصویری در صورت نیاز
        }
    };

    useEffect(() => {
        return () => {
            if (previewImage) {
                URL.revokeObjectURL(previewImage);
            }
        };
    }, [previewImage]);

    useEffect(() => {
        let config = {
            url: `${baseUrl}/company-ticket`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setAllShops(res.data.data.companies);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const showChatHandler = (id) => {
        setShopId(id);
        setShowChat(true);
        let config = {
            url: `${baseUrl}/${id}/ticket`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res &&
                    res.data &&
                    res.data.data &&
                    setTicketList(res.data.data.tickets);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const sendTicketHandler = (e) => {
        setTicketText("");
        setShowFilePreviewModal(false);
        let data = new FormData();
        data.append("company_id", shopId);
        data.append("content", ticketText);
        typeof avatar !== "string" && data.append("files[]", chatFile);
        let config = {
            url: `${baseUrl}/ticket`,
            method: "POST",
            data: data,
        };
        axios(config)
            .then((res) => {
                toast.success(res.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                showChatHandler(shopId);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    console.log(ticketList);
    const [compName, setCompName] = useState("");
    return (
        <div className="container">
            <div className="contact-main chat-div">
                <span className="titr"> تماس باما </span>
                {!showChat ? (
                    allShops &&
                    allShops.length !== 0 &&
                    allShops.map((item) => {
                        return (
                            <div
                                onClick={() => {
                                    showChatHandler(item.id);
                                    setCompName(item.name);
                                }}
                                className="contact-card"
                            >
                                <img src={item.avatar} alt="" />
                                <div>
                                    <span className="name">{item.name}</span>
                                    <span className="address">
                                        {item.address}
                                    </span>
                                </div>
                                <div className="chat-btn">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17 9C17 12.87 13.64 16 9.5 16L8.57001 17.12L8.02 17.78C7.55 18.34 6.65 18.22 6.34 17.55L5 14.6C3.18 13.32 2 11.29 2 9C2 5.13 5.36 2 9.5 2C12.52 2 15.13 3.67001 16.3 6.07001C16.75 6.96001 17 7.95 17 9Z"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            opacity="0.4"
                                            d="M22.0001 12.86C22.0001 15.15 20.8201 17.1801 19.0001 18.4601L17.6601 21.41C17.3501 22.08 16.4501 22.2101 15.9801 21.6401L14.5001 19.86C12.0801 19.86 9.92007 18.7901 8.57007 17.1201L9.50006 16.0001C13.6401 16.0001 17.0001 12.8701 17.0001 9.00006C17.0001 7.95006 16.7501 6.96007 16.3001 6.07007C19.5701 6.82007 22.0001 9.58005 22.0001 12.86Z"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            opacity="0.4"
                                            d="M7 9H12"
                                            stroke="white"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <>
                        <div className="chat-main" id="chat_main">
                            <div className="head">
                                <svg
                                    onClick={() => {
                                        setShowChat(false);
                                        setTicketList([]);
                                    }}
                                    width="15"
                                    height="26"
                                    viewBox="0 0 15 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M13.5 1L2.20711 12.2929C1.81658 12.6834 1.81658 13.3166 2.20711 13.7071L13.5 25"
                                        stroke="black"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                            <img
                                className="bg-shape"
                                src="./assets/images/bg-shape.png"
                                alt=""
                            />
                            <h6>{compName}</h6>
                            {ticketList && ticketList.length !== 0 ? (
                                ticketList.status == "unRead" ? (
                                    <div className="status waiting">
                                        در انتظار پاسخ
                                    </div>
                                ) : (
                                    <div className="status reply">
                                        پاسخ داده شده
                                    </div>
                                )
                            ) : (
                                ""
                            )}
                            <div className="pms">
                                {ticketList &&
                                    ticketList.map((item) => {
                                        if (item.type == "sent") {
                                            return (
                                                <div className="right-div">
                                                    <p className="pm-orang">
                                                        {item.content}
                                                        {item?.files &&
                                                        item?.files[0] &&
                                                        item?.files.length !==
                                                            0 ? (
                                                            <img
                                                                className="w-50"
                                                                src={
                                                                    item
                                                                        ?.files[0]
                                                                        ?.image
                                                                }
                                                                onClick={() => {
                                                                    setCurrentImage(
                                                                        item
                                                                            ?.files[0]
                                                                            ?.image
                                                                    );
                                                                    setShowImageModal(
                                                                        true
                                                                    );
                                                                }}
                                                                alt="Sent attachment"
                                                            />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </p>
                                                    <div className="time">
                                                        {item.created_at}
                                                    </div>
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <div className="left-div">
                                                    <p className="pm-blue">
                                                        {item.content}
                                                        {item?.files &&
                                                        item?.files[0] &&
                                                        item?.files.length !==
                                                            0 ? (
                                                            <img
                                                                className="w-50"
                                                                src={
                                                                    item
                                                                        ?.files[0]
                                                                        ?.image
                                                                }
                                                                onClick={() => {
                                                                    setCurrentImage(
                                                                        item
                                                                            ?.files[0]
                                                                            ?.image
                                                                    );
                                                                    setShowImageModal(
                                                                        true
                                                                    );
                                                                }}
                                                                alt="Received attachment"
                                                            />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </p>
                                                    <div className="time">
                                                        {item.created_at}
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })}
                                {/* <div className="center-date">1401/02/05</div> */}
                            </div>
                        </div>
                        <div className="inp-box">
                            <div className="inner">
                                <svg
                                    className="send"
                                    width="45"
                                    height="45"
                                    viewBox="0 0 45 45"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={sendTicketHandler}
                                >
                                    <circle
                                        cx="22.5"
                                        cy="22.5"
                                        r="22.5"
                                        fill="#F15A22"
                                    />
                                    <path
                                        d="M26.1536 14.8439L13.6449 18.7259C10.6751 19.6452 10.6326 23.8312 13.5813 24.8141L17.0178 25.9596C17.9724 26.2778 18.7219 27.0274 19.0401 27.982L20.1857 31.4185C21.1685 34.3671 25.3475 34.3176 26.2738 31.3549L30.1559 18.8461C30.9195 16.3854 28.6144 14.0802 26.1536 14.8439Z"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <input
                                    type="text"
                                    name="pm"
                                    placeholder="متن پیام ..."
                                    onChange={(e) =>
                                        setTicketText(e.target.value)
                                    }
                                    value={ticketText}
                                />
                                <input
                                    type="file"
                                    id="fileInput"
                                    style={{ display: "none" }}
                                    onChange={(e) =>
                                        handleFileChange(e.target.files[0])
                                    } // تابع برای پردازش فایل انتخاب شده
                                />
                                <svg
                                    className="plus"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() =>
                                        document
                                            .getElementById("fileInput")
                                            .click()
                                    } // کلیک روی svg باعث باز شدن دیالوگ فایل می‌شود
                                >
                                    <g opacity="0.4">
                                        <path
                                            d="M8 12H16"
                                            stroke="#FF9A51"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M12 16V8"
                                            stroke="#FF9A51"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <path
                                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                        stroke="#FF9A51"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </>
                )}
                {/* مودال پیش‌نمایش فایل */}
                {showFilePreviewModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <img
                                src={previewImage}
                                alt="Preview"
                                className="preview-image"
                            />
                            <div className="modal-buttons">
                                <button onClick={sendTicketHandler}>
                                    ارسال
                                </button>
                                <button
                                    onClick={() => {
                                        setShowFilePreviewModal(false);
                                        setChatFile(null);
                                        setPreviewImage(null);
                                    }}
                                >
                                    لغو
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* مودال نمایش تصویر بزرگ */}
                {showImageModal && (
                    <div
                        className="modal-overlay"
                        onClick={() => setShowImageModal(false)}
                    >
                        <div className="modal-content">
                            <img
                                src={currentImage}
                                alt="Full view"
                                className="full-image"
                            />
                        </div>
                    </div>
                )}
                <Menu active="setting" />
            </div>
        </div>
    );
};

export default ContactUs;
